<script setup lang="ts">
import type { PaletteColorProp } from '#imports';

interface IProps {
    scale?: number;
    color?: PaletteColorProp | string;
}
const { scale = 1, color = 'var(--blue-400)' } = defineProps<IProps>();
</script>

<template>
    <div class="show-box">
        <div class="loader" :style="{ transform: `scale(${scale})` }">
            <svg class="circular" viewBox="25 25 50 50">
                <circle
                    class="path"
                    :style="{ stroke: color }"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="3"
                    stroke-miterlimit="10"
                />
            </svg>
        </div>
    </div>
</template>

<style scoped lang="scss">
.circular {
    animation: rotate 2s linear infinite;
    height: 100%;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.loader {
    position: relative;
    margin: 0 auto;
    width: 70px;
}

.loader:before {
    content: '';
    display: block;
    padding-top: 100%;
}

.path {
    stroke-dasharray: 50, 100;
    stroke-dashoffset: 0;
    -webkit-animation: dash 1.5s ease-in-out infinite;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
    r: 20;
}

.show-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5%;
    overflow: hidden;
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }

    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}
</style>
